// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var LogIO = require("./LogIO.bs.js");
var Logger = require("./Logger.bs.js");
var Js_dict = require("bs-platform/lib/js/js_dict.js");
var DateUtils = require("./DateUtils.bs.js");
var Relude_Int = require("relude/src/Relude_Int.bs.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var StripeTypes = require("./bindings/StripeTypes.bs.js");
var Relude_Array = require("relude/src/Relude_Array.bs.js");
var Relude_Float = require("relude/src/Relude_Float.bs.js");
var Relude_Result = require("relude/src/Relude_Result.bs.js");
var Caml_primitive = require("bs-platform/lib/js/caml_primitive.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var CommonTypes_Shift = require("./types/CommonTypes_Shift.bs.js");
var CommonTypes_WorkerShift = require("./types/CommonTypes_WorkerShift.bs.js");

function couldNotRetrieveBalance(param_0) {
  return /* CouldNotRetrieveBalance */{
          _0: param_0
        };
}

function getRunningBalanceAdjustment(param) {
  var runningBalanceInCents = param.runningBalanceInCents;
  if (runningBalanceInCents < 0) {
    return Caml_primitive.caml_int_max(Math.imul(-1, param.amountInCents), runningBalanceInCents);
  } else {
    return runningBalanceInCents;
  }
}

function getPayoutAdjustedForBalance(payout) {
  return payout.amountInCents + getRunningBalanceAdjustment(payout) | 0;
}

function getInstantPayFeeForAmount(amount) {
  return Caml_primitive.caml_int_max(Relude_Float.floorAsInt(Relude_Int.toFloat(amount) * 0.03), 50);
}

function getStripeFeeForProfessionalPayout(payout) {
  if (payout.payoutMethod === "instant") {
    return getInstantPayFeeForAmount(getPayoutAdjustedForBalance(payout));
  } else {
    return 0;
  }
}

function getTotalPayout(payout) {
  return Caml_primitive.caml_int_max(getPayoutAdjustedForBalance(payout) - getStripeFeeForProfessionalPayout(payout) | 0, 0);
}

function getPayoutFromManualPayment(amount, payoutMethod, dropInstantFee, runningBalance, ignoreNegativeBalance) {
  return {
          amountInCents: amount,
          payoutMethod: payoutMethod === "instant" ? (
              dropInstantFee ? "instantNoFee" : "instant"
            ) : "standard",
          runningBalanceInCents: ignoreNegativeBalance && runningBalance < 0 ? 0 : runningBalance
        };
}

function getPayoutFromShift(payoutMethod, workerShiftDurationPay, workerRunningBalance) {
  return {
          amountInCents: Curry._1(CommonTypes_WorkerShift.DurationPayCents.toInt, workerShiftDurationPay),
          payoutMethod: typeof payoutMethod === "number" && payoutMethod === 0 ? "instant" : "standard",
          runningBalanceInCents: workerRunningBalance
        };
}

function getEstimatePayoutAmountInCents(startDatetime, endDatetime, workerRateCents) {
  return Relude_Float.floorAsInt(Relude_Int.toFloat(workerRateCents) * DateUtils.hoursBetween(startDatetime, endDatetime));
}

var isPaymentAboveLimit = Curry._1(Relude_Int.OrdNamed.greaterThan, 40000);

function getSourceTypeFromWhichToPayWorker(StripeModule, workerPayoutInCents) {
  var partial_arg = Curry._2(Relude_Array.foldLeft, (function (currentHighestSourceType, param) {
          var balance = param[1];
          var sourceType = param[0];
          if (currentHighestSourceType !== undefined && Curry._2(Relude_Float.Ord.compare, balance, currentHighestSourceType[1]) !== "greater_than") {
            return currentHighestSourceType;
          } else {
            return [
                    sourceType,
                    balance
                  ];
          }
        }), undefined);
  var partial_arg$1 = Curry._1(Relude_Array.flatMap, (function (param) {
          return Relude_Globals.$great$great((function (prim) {
                        return prim.source_types;
                      }), Js_dict.entries, param);
        }));
  var partial_arg$2 = function (param) {
    return Relude_Globals.$great$great((function (param) {
                  return Relude_Globals.$great$great((function (prim) {
                                return prim.available;
                              }), (function (param) {
                                return Relude_Array.filter((function (param) {
                                              return Relude_Globals.$great$great(StripeTypes.Balance.BalanceHash.currencyGet, (function (param) {
                                                            return param !== undefined;
                                                          }), param);
                                            }), param);
                              }), param);
                }), partial_arg$1, param);
  };
  var partial_arg$3 = function (param) {
    return Relude_Globals.$great$great(partial_arg$2, partial_arg, param);
  };
  var partial_arg$4 = function (param) {
    return LogIO.map(undefined, undefined, undefined, partial_arg$3, param);
  };
  var partial_arg$5 = function (param) {
    return Relude_Globals.$great$great((function (param) {
                  return Relude_Globals.$great$great(StripeModule.retrieveBalance, (function (param) {
                                return LogIO.mapError(undefined, undefined, undefined, couldNotRetrieveBalance, param);
                              }), param);
                }), partial_arg$4, param);
  };
  var partial_arg$6 = function (param) {
    return Relude_Globals.$great$great(partial_arg$5, (function (param) {
                  return LogIO.flatMap(undefined, undefined, undefined, (function (param) {
                                if (param !== undefined) {
                                  if (Curry._2(Relude_Float.Ord.compare, param[1], Relude_Int.toFloat(workerPayoutInCents)) === "less_than") {
                                    return Curry._1(LogIO.$$throw, /* InsufficientFunds */0);
                                  } else {
                                    return Curry._1(LogIO.pure, param[0]);
                                  }
                                } else {
                                  return Curry._1(LogIO.$$throw, /* NoSourcesFound */1);
                                }
                              }), param);
                }), param);
  };
  return function (param) {
    return Relude_Globals.$great$great(partial_arg$6, (function (param) {
                  return LogIO.bilog(undefined, undefined, undefined, undefined, (function (param) {
                                return Relude_Globals.$great$great((function (param) {
                                              return Relude_Result.fold((function (stripeError) {
                                                            if (typeof stripeError === "number") {
                                                              if (stripeError !== 0) {
                                                                return "No sources found to send a payment from ";
                                                              } else {
                                                                return "Not enough balance to send a payout";
                                                              }
                                                            }
                                                            var tmp;
                                                            switch (stripeError._0.TAG | 0) {
                                                              case /* CardError */0 :
                                                                  tmp = "Card error";
                                                                  break;
                                                              case /* InvalidRequestError */1 :
                                                                  tmp = "Invalid request";
                                                                  break;
                                                              case /* APIError */2 :
                                                                  tmp = "API error";
                                                                  break;
                                                              case /* ConnectionError */3 :
                                                                  tmp = "Connection error";
                                                                  break;
                                                              case /* AuthenticationError */4 :
                                                                  tmp = "Authentication error";
                                                                  break;
                                                              case /* RateLimitError */5 :
                                                                  tmp = "Rate limited";
                                                                  break;
                                                              case /* PermissionError */6 :
                                                                  tmp = "Permission error";
                                                                  break;
                                                              case /* IdempotencyError */7 :
                                                                  tmp = "Idempotency error";
                                                                  break;
                                                              case /* InvalidGrantError */8 :
                                                                  tmp = "Invalid grant";
                                                                  break;
                                                              case /* Unknown */9 :
                                                                  tmp = "Unknown";
                                                                  break;
                                                              
                                                            }
                                                            return "Could not retrieve balance. Stripe returned error: " + tmp;
                                                          }), (function (param) {
                                                            return "Sending payment from account:" + param;
                                                          }), param);
                                            }), Logger.Data.message, param);
                              }), param);
                }), param);
  };
}

function createStripeTransfer(currency, amount, destination, shiftId, transferGroup, payoutMethod, sourceType, idempotencyKey, StripeModule) {
  var tmp;
  if (shiftId !== undefined) {
    var shiftId$1 = Caml_option.valFromOption(shiftId);
    tmp = transferGroup !== undefined ? Curry._1(CommonTypes_Shift.Id.toString, shiftId$1) + ("-" + (transferGroup + "-")) : Curry._1(CommonTypes_Shift.Id.toString, shiftId$1) + "-";
  } else {
    tmp = transferGroup !== undefined ? transferGroup + "-" : "";
  }
  var __x = Curry._5(StripeTypes.Transfer.Create.Payload.make, currency, amount, destination, tmp + (
        payoutMethod === "instant" ? "instant" : "standard"
      ), sourceType);
  var partial_arg = Curry._2(StripeModule.createTransfer, __x, StripeTypes.SuperSecretStripeOptions.make(undefined, idempotencyKey, undefined, undefined, undefined));
  return function (param) {
    return Relude_Globals.$great$great(partial_arg, (function (param) {
                  return LogIO.map(undefined, undefined, undefined, (function (prim) {
                                return prim.id;
                              }), param);
                }), param);
  };
}

function createStripePayout(currency, amount, stripeAccount, paymentMethod, sourceType, idempotencyKey, StripeModule) {
  return Curry._2(StripeModule.createPayout, Curry._4(StripeTypes.Payout.Create.Payload.make, currency, paymentMethod, amount, sourceType), StripeTypes.SuperSecretStripeOptions.make(undefined, idempotencyKey, Caml_option.some(stripeAccount), undefined, undefined));
}

var insufficientFunds = /* InsufficientFunds */0;

var noSourcesFound = /* NoSourcesFound */1;

var maximumPaymentInCents = 40000;

exports.couldNotRetrieveBalance = couldNotRetrieveBalance;
exports.insufficientFunds = insufficientFunds;
exports.noSourcesFound = noSourcesFound;
exports.getRunningBalanceAdjustment = getRunningBalanceAdjustment;
exports.getPayoutAdjustedForBalance = getPayoutAdjustedForBalance;
exports.getInstantPayFeeForAmount = getInstantPayFeeForAmount;
exports.getStripeFeeForProfessionalPayout = getStripeFeeForProfessionalPayout;
exports.getTotalPayout = getTotalPayout;
exports.getPayoutFromManualPayment = getPayoutFromManualPayment;
exports.getPayoutFromShift = getPayoutFromShift;
exports.getEstimatePayoutAmountInCents = getEstimatePayoutAmountInCents;
exports.maximumPaymentInCents = maximumPaymentInCents;
exports.isPaymentAboveLimit = isPaymentAboveLimit;
exports.getSourceTypeFromWhichToPayWorker = getSourceTypeFromWhichToPayWorker;
exports.createStripeTransfer = createStripeTransfer;
exports.createStripePayout = createStripePayout;
/* isPaymentAboveLimit Not a pure module */
